import React from 'react'
import AddModel from '../../pages/addModel'
import ButtonComp from '../button/ButtonComp'
import { Descriptions, Popconfirm, Button, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { useSelector } from 'react-redux';

const ProductService = ({
    products,
    isProductModal,
    showProductModal,
    handleCancelModal,
    addProductFrom,
    handleProduct,
    deleteProduct,
}) => {
    const select = useSelector((state) => state.auth);
    const user_role = select.userInfo.role;
    return (
        <div>
            <div className=" text-black pb-3 px-2 flex items-center justify-between">
                <span>
                    <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">
                        Products / Services
                    </h1>
                </span>

                {(user_role && user_role.toLowerCase() === "admin") ||
                    user_role.toLowerCase() === "superadmin" ? (
                    <ButtonComp
                        text="Add Product / Service"
                        bgColor="#4E36A3"
                        textColor="white"
                        onClick={showProductModal}
                    />
                ) : (
                    ""
                )}
            </div>
            <Descriptions.Item
                label="Product / Service"
                span={1}
            // className="text-center"
            >
                {products &&
                    products.map((product, index) => (
                        <div key={product.id} className="bg-purple-50 py-2 px-5 mb-3">
                            <h1
                                key={product.id}
                                value={product.id}
                                className="mt-1 font-medium"
                            >
                                <div className="delete_department">
                                    <span className="text-[12px] font-[500]">{product.product_name}</span>
                                    {(user_role &&
                                        user_role.toLowerCase() === "admin") ||
                                        user_role.toLowerCase() === "superadmin" ? (
                                        <span>
                                            <Popconfirm
                                                title="Delete Product / Service"
                                                description="Are you sure to delete this Product / Service?"
                                                okText="Yes"
                                                cancelText="No"
                                                placement="bottomLeft"
                                                onConfirm={() =>
                                                    deleteProduct(product.product_name)
                                                }
                                            >
                                                <Button danger>
                                                    <DeleteOutlined />
                                                </Button>
                                            </Popconfirm>
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </h1>
                        </div>

                    ))}
                <AddModel title='Product / Service Name' isOpen={isProductModal} handleCancelModal={handleCancelModal}
                    from={addProductFrom} name={['dynamic_form_product', 'product_list']} onFinish={handleProduct} />
            </Descriptions.Item>
        </div>
    )
}

export default ProductService
